import React from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

interface DefaultFiltersButtonProps {
    isDefault: boolean;
    loading: boolean;
    hasUserDefault: boolean;
    onRemoveDefault: () => void;
    onSaveOrUpdate: () => void;
    variant?: "text" | "outlined" | "contained";
    color?: "info";
    className?: string;
    style?: React.CSSProperties;
}

const DefaultFiltersButton: React.FC<DefaultFiltersButtonProps> = ({
    isDefault,
    loading,
    hasUserDefault,
    onRemoveDefault,
    onSaveOrUpdate,
    variant = "contained",
    color = "info",
    className,
    style,
}) => {
    const { t } = useTranslation();

    const handleClick = () => {
        if (isDefault) {
            onRemoveDefault();
            return;
        }
        onSaveOrUpdate();
    };

    const label = isDefault
        ? t("locations.mill_dashboards.remove_default_filters")
        : hasUserDefault
        ? t("locations.mill_dashboards.update_default_filters")
        : t("locations.mill_dashboards.save_default_filters");

    return (
        <Button
            variant={variant}
            color={color}
            className={className}
            disabled={loading}
            onClick={handleClick}
            style={style}
        >
            {label}
        </Button>
    );
};

export default DefaultFiltersButton;
